import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Note } from '@myxplor/ui'
import WeekDay from './day'
import CasualSession from './casual-session'
import { sessionTemplate, duplicateWeek } from './helpers'
import { daysOfWeek, isWeekend } from '../../../../../../week'
import FortnightlyToggle from './fortnightly-toggle'
import './week.css'

class BookingScheduleForm extends Component {
  constructor(props) {
    super(props)
    this.changeEditingSession = this.changeEditingSession.bind(this)
    this.toggleFrequency = this.toggleFrequency.bind(this)
    this.toggleSelectedFreq = this.toggleSelectedFreq.bind(this)

    this.state = {
      dayIndex: undefined,
      weekIndex: undefined,
      frequency: {
        weekly: true,
        fortnightly: false,
        casual: false
      }
    }
  }


  toggleSelectedFreq(frequency) {
    const isSelected = true

    switch(frequency) {
      case 'weekly':
        this.setState({frequency: {weekly: isSelected, fortnightly: !isSelected, casual: !isSelected}})
        break
      case 'fortnightly':
        this.setState({frequency: {weekly: !isSelected, fortnightly: isSelected, casual: !isSelected}})
        break
      case 'casual':
        this.setState({frequency: {weekly: !isSelected, fortnightly: !isSelected, casual: isSelected}})
        break
      default:
        break
    }
  }

  toggleFrequency(frequency) {
    const { addKey, values } = this.props

    if (frequency === 'fortnightly') {
      // We need to duplicate week 1
      addKey(['week2'], duplicateWeek(values.week1), true)
      addKey(['is_casual'], false, true)
      addKey(['is_fortnightly'], true, true)
      this.toggleSelectedFreq('fortnightly')
    } else if (frequency === 'casual') {
      addKey(['casual'], values.casual, true)
      addKey(['is_casual'], true, true)
      addKey(['is_fortnightly'], false, true)
      this.toggleSelectedFreq('casual')
    } else {
      addKey(['is_casual'], false, true)
      addKey(['is_fortnightly'], false, true)
      this.toggleSelectedFreq('weekly')
    }
  }

  changeEditingSession({ weekIndex, dayIndex, sessionIndex }) {
    this.setState({
      weekIndex,
      dayIndex,
      sessionIndex,
    })
  }

  renderDay({ weekIndex, day, dayIndex, sessionTemplate }) {
    const { values, onChange, addKey, removeKey, careEnrolmentOptions } = this.props
    return (
      <WeekDay
        key={`${weekIndex}_${dayIndex}`}
        day={day}
        sessions={values ? values['week' + weekIndex][dayIndex + 1] : []}
        onChange={onChange}
        nameBase={`week${weekIndex}.${dayIndex + 1}`}
        addKey={addKey}
        removeKey={removeKey}
        sessionTemplate={sessionTemplate}
        editingDay={this.state.editingDay}
        changeEditingSession={sessionIndex =>
          this.changeEditingSession({ weekIndex, dayIndex, sessionIndex })
        }
        resetEditingSession={() =>
          this.changeEditingSession({ weekIndex: null, dayIndex: null, sessionIndex: null })
        }
        isEditing={{
          today: this.state.weekIndex === weekIndex && this.state.dayIndex === dayIndex,
          sessionIndex: this.state.sessionIndex,
        }}
        isWeekend={isWeekend(day.value)}
        careEnrolmentOptions={careEnrolmentOptions}
      />
    )
  }

  renderCasualSession() {
    const { values, onChange, careEnrolmentOptions } = this.props
    return (
      <CasualSession
        nameBase="casual"
        session={values.casual}
        onChange={onChange}
        careEnrolmentOptions={careEnrolmentOptions}
      />
    )
  }

  render() {
    const { values, careEnrolmentOptions } = this.props
    const { fortnightly, casual } = this.state.frequency

    return (
      <Fragment>
        <FortnightlyToggle onChange={this.toggleFrequency} selectedFreq={this.state.frequency} />

        {fortnightly && (
          <Note important>
            Please note, the fortnightly schedule will be synchronised to dates provided by the
            government. For example, the{' '}
            {moment(values.reference_date, 'YYYY-MM-DD').format('Do [of] MMMM')} and the{' '}
            {moment(values.reference_date, 'YYYY-MM-DD')
              .add(2, 'week')
              .format('Do [of] MMMM')}{' '}
            are both the start of a Week 1.
          </Note>
        )}

        {fortnightly && <h3 className="weekCycle--heading">Week 1</h3>}

        {!casual && (
          <Fragment>
            <div className="week">
              {daysOfWeek.map((day, i) =>
                this.renderDay({
                  day,
                  weekIndex: 1,
                  dayIndex: i,
                  sessionTemplate: sessionTemplate({ sessions: values.week1, careEnrolmentOptions }),
                })
              )}
            </div>
          </Fragment>)
        }

        {casual && (
          <Fragment>
            <div className="week">
              {this.renderCasualSession({
                  sessionTemplate: sessionTemplate({ sessions: values.casual, careEnrolmentOptions }),
                })
              }
            </div>
          </Fragment>
        )}

        {fortnightly && (
          <Fragment>
            <h3 className="weekCycle--heading">Week 2</h3>
            <div className="week">
              {daysOfWeek.map((day, i) =>
                this.renderDay({
                  key: i,
                  day,
                  weekIndex: 2,
                  dayIndex: i,
                  sessionTemplate: sessionTemplate({
                    sessions: values.week2 || values.week1,
                    careEnrolmentOptions,
                  }),
                })
              )}
            </div>
          </Fragment>
        )}
      </Fragment>
    )
  }
}

export default BookingScheduleForm



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/container.jsx